/* Others */
import { getBooleanFromEnvVariable } from "../../utils";

/* Constants */
const BASE_AEM_PATH = "/bin/ott/";
const IS_BR = getBooleanFromEnvVariable("REACT_APP_BRAZIL");
const IS_PROD_ENV = getBooleanFromEnvVariable("REACT_APP_IS_PRODUCTION_ENV");
export const CONVIVA_PROD = "https://cws.conviva.com";
export const GA = "https://www.google-analytics.com/collect";

export const FORGE_ROCK = {
  pinLoginSSOToken: `${process.env.REACT_APP_FORGE_ROCK_BASE_PATH}${
    IS_PROD_ENV ? "" : ":443"
  }/openam/json/realms/root/realms/${
    IS_BR ? "br" : "ssla"
  }/authenticate?authIndexType=module&authIndexValue=OIDCBearer`,
  registerPinLogin: `${process.env.REACT_APP_FORGE_ROCK_BASE_PATH}:443/openam/oauth2/device/user`,
  tokenRefreshUrl: `${process.env.REACT_APP_FORGE_ROCK_BASE_PATH}:443/openam/oauth2/realms/root/realms/${
    IS_BR ? "br" : "ssla"
  }/access_token`,
  patchUserUrl: `${process.env.REACT_APP_FORGE_ROCK_BASE_PATH}${
    IS_PROD_ENV ? "" : ":443"
  }/openidm/endpoint/v2/patchUser`,
  logout: `${process.env.REACT_APP_FORGE_ROCK_BASE_PATH}${IS_PROD_ENV ? "" : ":443"}/openam/json/realms/root/realms/${
    IS_BR ? "br" : "ssla"
  }/sessions/?_action=logout`,
  deviceLogin: `${process.env.REACT_APP_FORGE_ROCK_BASE_PATH}/openam/oauth2/realms/root/realms/${
    IS_BR ? "br" : "ssla"
  }/device/user?nonce={deviceId}`
};

export const AEM = {
  interstitial: `${BASE_AEM_PATH}interstitial`,
  mobileConfig: `${BASE_AEM_PATH}mobileweb`
};
